import React from 'react';
import { Link } from 'react-router-dom';

const Components = {};




Components[ 'status' ] = {
  meta: {
    sort: true,
    filter: true
  },
  label: '',
  fields: [],

  Filter: ({ handle, meta, params, context, updateParams }) => {

  },

  loadContext: async ({ handle, meta, result }) => {

  },

  loadData: async ({ handle, meta, record, result }) => {

  },

  Input: ({ handle, meta, record, context, onFieldChange }) => {
    
  },

  Output: ({ handle, meta, record }) => {

    const StatusBadge = require( '../../../components/ui/StatusBadge' ).default;

    return <StatusBadge value={record.data.status} />;
  },

  validate: ({ handle, meta, record }) => {
    return record.status || null;
  }
};





Components[ 'text' ] = {
  meta: {
    sort: true,
    filter: true
  },
  label: 'Text',
  fields: [
    {
      handle: 'length',
      label: 'Length',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
    {
      handle: 'required',
      label: 'Required',
      field: {
        meta: {
        },
        value: 'boolean'
      }
    }
  ],

  Filter: ({ handle, meta, params, context, updateParams }) => {
    return (
      <input
        type="text"
        placeholder={meta.placeholder || ''}
        value={params[ handle ] || ''}
        onChange={(event) => updateParams({ [ handle ]: event.target.value, page: 1 })}
      />
    );
  },

  loadContext: async ({ handle, meta, result }) => {

  },

  loadData: async ({ handle, meta, record, result }) => {

  },

  Input: ({ handle, meta, record, context, onFieldChange }) => (
    <input
      type="text"
      value={record.data[ handle ]}
      onChange={(e) => onFieldChange(handle, e.target.value)}
      required={meta.required}
    />
  ),

  Output: ({ handle, meta, record }) => {
    return record.data[ handle ] || '-';
  },

  validate: ({ handle, meta, record }) => {
    return record[ handle ] || null;
  }
};





Components[ 'textarea' ] = {
  meta: {
    wide: true
  },
  label: 'Text Area',
  fields: [
    {
      handle: 'length',
      label: 'Length',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
    {
      handle: 'required',
      label: 'Required',
      field: {
        meta: {
        },
        value: 'boolean'
      }
    }
  ],

  Filter: ({ handle, meta, params, context, updateParams }) => {

  },

  loadContext: async ({ handle, meta, result }) => {

  },

  loadData: async ({ handle, meta, record, result }) => {

  },

  Input: ({ handle, meta, record, context, onFieldChange }) => {
    return (
      <textarea
        value={record.data[ handle ]}
        onChange={(e) => onFieldChange(handle, e.target.value)}
        required={meta.required}
      />
    );
  },

  Output: ({ handle, meta, record }) => {
    return record.data[ handle ] ? <p>{record.data[ handle ]}</p> : '-';
  },

  validate: ({ handle, meta, record }) => {
    return record[ handle ] || null;
  }
};





Components[ 'relation' ] = {
  meta: {
    sort: true,
    filter: true
  },
  label: 'Relation',
  fields: [
    {
      handle: 'link',
      label: 'Link',
      field: {
        meta: {
        },
        value: 'model'
      }
    },
    {
      handle: 'required',
      label: 'Required',
      field: {
        meta: {
        },
        value: 'boolean'
      }
    }
  ],

  Filter: ({ handle, meta, params, context, updateParams }) => {

    const Model = context[`${handle}Model`] || {
      handle: {
        handle: 'id' 
      } 
    };

    const {
      pageReset = true,
    } = meta;

    return (
      <select
        value={params[ handle ] || ''}
        onChange={(event) => updateParams({ [ handle ]: event.target.value, ...(pageReset ? { page: 1 } : {}), })}
      >
        <option value="">All</option>

        {context[ handle ]?.map((row) => (
          <option key={row.id} value={row.id}>
            {row[ Model.handle?.handle || 'id' ]}
          </option>
        ))}

      </select>
    );
  },

  loadContext: async ({ handle, meta, result }) => {
     
    const Factory = require( '../../../records/modules' ).default;

    const response = await Factory( {
      slug: meta.link
    } ).Data.getRecords( {
      page: 1,
      limit: 100,
      sort: 'updatedAt',
      order: 'ASC'
    } );

    result[ handle ] = response.data;


    result[`${handle}Model`] = await Factory( {
      slug: 'models'
    } ).Meta.getRecord( meta.link );
  },

  loadData: async ({ handle, meta, record, result }) => {

    const Factory = require('../../../records/modules' ).default;
    
    result[ handle ] = record[ handle ] ? await Factory( {
      slug: meta.link
    } ).Data.getRecord( record[ handle ] ) : null;


    result[`${handle}Model`] = await Factory( {
      slug: 'models'
    } ).Meta.getRecord( meta.link );
  },

  Input: ({ handle, meta, record, context, onFieldChange }) => {

    const relationModel = record[`${handle}Model`] || context[`${handle}Model`] || { handle: { handle: 'id' } };

    const labelKey = relationModel.handle?.handle || 'id';

    return (
      <select
        value={record.data[ handle ]}
        onChange={(e) => onFieldChange(handle, e.target.value)}
        required={meta.required}
      >
        <option value="">-</option>

        { record[ handle ] ? (
          <option key={record[ handle ].id} value={record[ handle ].id}>
            {record[ handle ][ labelKey ]}
          </option>
        ) : null}

        {context[ handle ]?.map((option) => option.id !== record.data.id ? (
          <option key={option.id} value={option.id}>
            {option[ labelKey ]}
          </option>
        ) : null )}
      </select>
    );
  },

  Output: ({ handle, meta, record }) => {

    const relationModel = record[`${handle}Model`] || { handle: { handle: 'id' } };

    const labelKey = relationModel.handle?.handle || 'id';

    return record[ handle ] ? (
      <Link className="inline-link" to={`/${meta.link}/${record[ handle ].id}`}>
        {record[ handle ][ labelKey ]}
      </Link>
    ) : '-';
  },

  validate: ({ handle, meta, record }) => {
    return record[ handle ] || null;
  }
};





Components[ 'number' ] = {
  meta: {
    sort: true,
    filter: true
  },
  label: 'Number',
  fields: [
    {
      handle: 'min',
      label: 'Min',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
    {
      handle: 'max',
      label: 'Max',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
    {
      handle: 'step',
      label: 'Step',
      field: {
        meta: {
        },
        value: 'text'
      }
    },
    {
      handle: 'required',
      label: 'Required',
      field: {
        meta: {
        },
        value: 'boolean'
      }
    }
  ],

  Filter: ({ handle, meta, params, context, updateParams }) => {
    return (
      <input
        type="number"
        min={meta.min}
        max={meta.max}
        step={meta.step}
        placeholder={meta.placeholder || ''}
        value={params[ handle ] || ''}
        onChange={(event) => updateParams({ [ handle ]: event.target.value, page: 1 })}
      />
    );
  },

  loadContext: async ({ handle, meta, result }) => {

  },

  loadData: async ({ handle, meta, record, result }) => {

  },

  Input: ({ handle, meta, record, context, onFieldChange }) => (
    <input
      type="number"
      min={meta.min}
      max={meta.max}
      step={meta.step}
      value={record.data[ handle ]}
      onChange={(e) => onFieldChange(handle, e.target.value)}
      required={meta.required}
    />
  ),

  Output: ({ handle, meta, record }) => {
    return record.data[ handle ] || '-';
  },

  validate: ({ handle, meta, record }) => {
    return Number( record[ handle ] );
  }
};





Components[ 'date' ] = {
  meta: {
    sort: true,
    filter: true
  },
  label: 'Date',
  fields: [
    {
      handle: 'required',
      label: 'Required',
      field: {
        meta: {
        },
        value: 'boolean'
      }
    }
  ],

  Filter: ({ handle, meta, params, context, updateParams }) => {
    return (
      <input
        type="date"
        placeholder={meta.placeholder || ''}
        value={params[ handle ] || ''}
        onChange={(event) => updateParams({ [ handle ]: event.target.value, page: 1 })}
      />
    );
  },

  loadContext: async ({ handle, meta, result }) => {

  },

  loadData: async ({ handle, meta, record, result }) => {

  },

  Input: ({ handle, meta, record, context, onFieldChange }) => (
    <input
      type="date"
      value={record.data[ handle ]}
      onChange={(e) => onFieldChange(handle, e.target.value)}
      required={meta.required}
    />
  ),

  Output: ({ handle, meta, record }) => {
    return record.data[ handle ] || '-';
  },

  validate: ({ handle, meta, record }) => {
    return record[ handle ] || null;
  }
};

Components[ 'computed' ] = {
  meta: {
    sort: false,
    filter: false,
    wide: true,
  },
  label: 'Computed',
  fields: [
    {
      handle: 'formula',
      label: 'Numeric Formula',
      field: {
        meta: {},
        value: 'textarea',
      },
    },
  ],
  Filter: () => null,
  loadContext: async () => {},
  loadData: async () => {},
  Input: () => <p>Computed from this record's numeric fields.</p>,
  Output: ({ handle, record }) => record.data?.[handle] ?? '-',
  validate: () => undefined,
};

Components[ 'rollup' ] = {
  meta: {
    sort: false,
    filter: false,
    wide: true,
  },
  label: 'Rollup',
  fields: [
    {
      handle: 'association',
      label: 'Child Association',
      field: {
        meta: {},
        value: 'text',
      },
    },
    {
      handle: 'operation',
      label: 'Operation (count, sum, average, min, max)',
      field: {
        meta: {},
        value: 'text',
      },
    },
    {
      handle: 'field',
      label: 'Child Number Field',
      field: {
        meta: {},
        value: 'text',
      },
    },
  ],
  Filter: () => null,
  loadContext: async () => {},
  loadData: async () => {},
  Input: () => <p>Aggregated from records in the selected child association.</p>,
  Output: ({ handle, record }) => record.data?.[handle] ?? '-',
  validate: () => undefined,
};



export default Components;